import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
// import formFields from "./formFields";
import formFields, { slotSizeOptions } from "./formFields";
import createAd from "../Create-Ad/createAd.css";
// import "../Forms/form.css";

const validationSchema = Yup.object({
  gen_type: Yup.string().required("Gen Type is required"),
  site_id: Yup.string().required("Domain name is required"),
  ad_display_name: Yup.string().required("Ad Display Name is required"),
  adunit_name: Yup.string().required("Adunit Name is required"),
  platform_type: Yup.string().required("Platform Type is required"),
  htag: Yup.string().required("Head Tag is required"),
  btag: Yup.string().required("Body Tag is required"),
  device: Yup.string().required("Device Type is required"),
  // slot_size: Yup.string().required("Slot Size is required"),
  design_format: Yup.string().required("Design Format is required"),
    design_format: Yup.string()
    .test(
      "is-valid-selection",
      "Design Format is required",
      (value) => value !== "__please_select__"
    ),
  status: Yup.string().required("status is required"),
  is_visible: Yup.string().required("Visible on reporting is required"),
  
  ad_multitags: Yup.array().of(
    Yup.object().shape({
      htag: Yup.string().required("Multi-tag Head Tag is required"),
      btag: Yup.string().required("Multi-tag Body Tag is required"),
      gptid: Yup.string().required("GPT-ID is required"),
      slot_var: Yup.string().required("Slot variable is required"),
      status: Yup.string().required("Status is required"),
      is_visible: Yup.string().required("Visible on reproting is required"),
    })
  ),
});

const CreateForm = () => {
  const { pubId, siteId } = useParams(); // Get publisher ID from URL
   const navigate = useNavigate();
  const [domainList, setDoaminList] = useState([]);
  const [message, setMessage] = useState("");
  const [slotOptions, setSlotOptions] = useState([]);
  const [selectedGenType, setSelectedGenType] = useState("");
  const [selectedDevice, setSelectedDevice] = useState("desktop");
  // const [multiTags, setMultiTags] = useState([""]);
  // const [fieldFormData, setFieldFormData] = useState(initialFieldForm); // where initialFieldForm is your JSON array

  const mobileSlotSizes = [
    "300*250", "336*280", "320*480", "320*250", "300*400", "320*400", "250*250",
    "200*200", "250*360", "240*400", "300*600", "160*600", "120*600", "320*100",
    "300*100", "320*75", "300*75", "320*50", "300*50", "234*60", "120*60",
  ];
  
  const desktopSlotSizes = [
    "300*250", "336*280", "320*480", "320*250", "300*400", "480*320", "250*250",
    "200*200", "320*400", "250*360", "240*400", "300*600", "160*600", "120*600", "750*300", "580*400", "468*60",
    "728*90", "970*90", "970*250", "960*60", "640*60", "460*60", "580*90",
  ];

  const handleDeviceChange = (value, setFieldValue) => {
    // const slots = device === "mobile" ? mobileSlotSizes : desktopSlotSizes;
    // setSlotOptions(slots);
    // setFieldValue("slot_size", "");
    setSelectedDevice(value);
    setFieldValue("device", value);
    setFieldValue("slot_size", ""); // Reset slot_size when device changes
    // const options = value === "mobile" ? mobileSlotSizes : value === "desktop" ? desktopSlotSizes : [];
    // setSlotOptions(options);
    setSlotOptions(slotSizeOptions[value] || []);
    // if (selectedDevice === 'mobile') {
    //   setSlotOptions(mobileSlotSizes);
    // } else if (selectedDevice === 'desktop') {
    //   setSlotOptions(desktopSlotSizes); // <- Is this defined?
    // }
  };

  const generateIdOnce = (keyName) => {
    // const storedValue = localStorage.getItem(keyName);
    // if (storedValue) {
      // return storedValue;
    // } else {
      let newValue;
      if (keyName === "generated_slot_var") {
        const randomNumber = Math.floor(1000 + Math.random() * 9000);
        newValue = `CXSlot${randomNumber}`;
      } else {
        newValue = 'CX-' + uuidv4();
      }
      // localStorage.setItem(keyName, newValue);
      return newValue;
    // }
  };

  const initialValues = formFields.reduce((acc, field) => {
    if (field.name === "adunit_id") {
      acc[field.name] = "0000";
    } else if (field.name === "account_id") {
      acc[field.name] = pubId || "";
    } else if (field.name === "site_id") {
      acc[field.name] = siteId || "";
    } else if (field.name === "pid") {
      acc[field.name] = generateIdOnce("generated_pid");
    } else if (field.name === "elmid") {
      acc[field.name] = generateIdOnce("generated_elmid");
    } else if (field.name === "elmcl") {
      acc[field.name] = generateIdOnce("generated_elmcl");
    } else if (field.name === "delaytime") {
      acc[field.name] = "10";
    } else if (field.default !== undefined) {
      acc[field.name] = field.default;
    } else if (field.name === "slot_var") {
      acc[field.name] = generateIdOnce("generated_slot_var");
    } else {
      acc[field.name] = "";
    }
    return acc;
  }, {});
// 👇 Add ad_multitags group
initialValues.ad_multitags = [];
// apply customize without multitag
  // const handleCustomizeApply = (values, setFieldValue) => {
  //   let updatedHtag = values.htag;
  //   let updatedBtag = values.btag;

  //   if (updatedHtag) {
  //     updatedHtag = updatedHtag.replace(
  //       /(window\.googletag\s*=\s*window\.googletag\s*\|\|\s*\{cmd:\s*\[\]\};)/,
  //     `$1\n  googletag.cmd = googletag.cmd || [];`
  //     );
  //     updatedHtag = updatedHtag.replace(
  //      /googletag\.defineSlot\(([^)]+)\)\.addService\(googletag\.pubads\(\)\);/,
  //      `window.ACX_GPTSLOT = googletag.defineSlot($1, 'ACX_GPTID').addService(googletag.pubads());`
  //     // `window.ACX_GPTSLOT = $1`.replace(/'div-gpt-ad-\d+-\d+'/g, "'ACX_GPTID'")
  //     );
  //     updatedHtag = updatedHtag.replace(/'div-gpt-ad-\d+-\d+'/g, "'ACX_GPTID'");
  //   }

  //   if (updatedBtag) {
  //     updatedBtag = updatedBtag.replace(/'div-gpt-ad-\d+-\d+'/g, "'ACX_GPTID'");
  //   }

  //   setFieldValue("custom_htag", updatedHtag);
  //   setFieldValue("custom_btag", updatedBtag);
  // };

  const handleCustomizeApply = (values, setFieldValue) => {
  let updatedHtag = values.htag;
  let updatedBtag = values.btag;

  if (updatedHtag) {
    // Ensure googletag initialization is included
    updatedHtag = updatedHtag.replace(
      /(window\.googletag\s*=\s*window\.googletag\s*\|\|\s*\{cmd:\s*\[\]\};)/,
      `$1\n  googletag.cmd = googletag.cmd || [];`
    );

    // Replace defineSlot(...) with window.ACX_GPTSLOT = defineSlot(...)
    updatedHtag = updatedHtag.replace(
      /googletag\.defineSlot\(([^)]+)\)\.addService\(googletag\.pubads\(\)\);/,
      (match, slotArgs) => {
        const updatedSlotArgs = slotArgs.replace(/'div-gpt-ad-\d+-\d+'/g, "'ACX_GPTID'");
        return `window.ACX_GPTSLOT = googletag.defineSlot(${updatedSlotArgs}).addService(googletag.pubads());`;
      }
    );
  }

  if (updatedBtag) {
    updatedBtag = updatedBtag.replace(/'div-gpt-ad-\d+-\d+'/g, "'ACX_GPTID'");
  }

  setFieldValue("custom_htag", updatedHtag);
  setFieldValue("custom_btag", updatedBtag);
};


  // apply customize to multitag
  const handleMultiCustomize = (index, values, setFieldValue) => {
    let updatedHtag = values.ad_multitags[index].htag;
    let updatedBtag = values.ad_multitags[index].btag;
  
    if (updatedHtag) {
      updatedHtag = updatedHtag.replace(
        /(window\.googletag\s*=\s*window\.googletag\s*\|\|\s*\{cmd:\s*\[\]\};)/,
        `$1\n  googletag.cmd = googletag.cmd || [];`
      );
      updatedHtag = updatedHtag.replace(
        /googletag\.defineSlot\(([^)]+)\)\.addService\(googletag\.pubads\(\)\);/,
        (match, slotArgs) => {
        const updatedSlotArgs = slotArgs.replace(/'div-gpt-ad-\d+-\d+'/g, "'ACX_GPTID'");
        return `window.ACX_GPTSLOT = googletag.defineSlot(${updatedSlotArgs}).addService(googletag.pubads());`;
      }
      );
      // updatedHtag = updatedHtag.replace(/'div-gpt-ad-\d+-0'/g, "'DIV-GPT-ID'");
    }
  
    if (updatedBtag) {
    updatedBtag = updatedBtag.replace(/'div-gpt-ad-\d+-\d+'/g, "'ACX_GPTID'");
  }
  
    setFieldValue(`ad_multitags[${index}].custom_htag`, updatedHtag);
    setFieldValue(`ad_multitags[${index}].custom_btag`, updatedBtag);
  };
  const token = localStorage.getItem("token"); // Get token from storage
  //get all domain list 
  const alldomainList = async () =>{
    try {
          const alldomainListRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getAllSites/${pubId}`, {
                  headers : {
                      Authorization: `Bearer ${token}`,
                      "Content-Type": "application/json",
                      Accept: "application/json",
                  },
              }
            );
              console.log(alldomainListRes.data.data);
              if(alldomainListRes.status === 200){
                  setDoaminList(alldomainListRes.data.data);
              }else {
                setMessage("No domains found.");
              }
      } catch (error) {
        console.log(error);
        console.log(error.alldomainListRes);
        
        if (error?.status === 401) {
          console.error("Unauthorized! Token might be expired.");
          localStorage.removeItem("token");
          navigate("/admin");
        } else {
          console.error("Error fetching data:", error);
        }
        setMessage("Error fetching domain list.");
      } 
      // finally {
      //     setLoading(false);
      //   }      
  } 
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
     const cleanedValues = {};
      for (const key in values) {
        cleanedValues[key] = values[key] === "__please_select__" ? "" : values[key];
      }
        // ✅ Clear unrelated fields based on gen_type
        if (cleanedValues.gen_type === "id") {
          cleanedValues.elmcl = "";
          cleanedValues.elmclidx = "";
        } else if (cleanedValues.gen_type === "class") {
          cleanedValues.elmid = "";
        }
        if (cleanedValues.syncst) {
          cleanedValues.syncst = cleanedValues.syncst.replace("T", " ");
        }
        if (cleanedValues.syncend) {
          cleanedValues.syncend = cleanedValues.syncend.replace("T", " ");
        }
    const payload = {
      ...cleanedValues,
      // ad_multitags: multiTags.filter(tag => tag.trim() !== ""),
      visibleonpagesArr: Array.isArray(cleanedValues.visibleonpagesArr)
        ? cleanedValues.visibleonpagesArr.join(",")
        : cleanedValues.visibleonpagesArr || "",
      notvisibleonpagesArr: Array.isArray(cleanedValues.notvisibleonpagesArr)
        ? cleanedValues.notvisibleonpagesArr.join(",")
        : cleanedValues.notvisibleonpagesArr || "",
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/createAdPlacement`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      console.log(response.data);
      console.log(response.data.success);
      if (response.data.status == 1) {
        alert("Ad Placements Created Successfully!");
        resetForm();
        navigate(-1)
        // setMultiTags([""]);
      } else {
        alert("Something went wrong: " + (response.data.message || "Unknown Error"));
      }
    } catch (error) {
      console.error("Error creating Ad Placement:", error);
      alert("API Error: " + (error.response?.data?.message || error.message));
    } finally {
      setSubmitting(false);
    }
  };

  // const handleAddTag = () => setMultiTags([...multiTags, ""]);
  // const handleRemoveTag = (index) => {
  //   const updated = [...multiTags];
  //   updated.splice(index, 1);
  //   setMultiTags(updated);
  // };
  // const handleTagChange = (index, value) => {
  //   const updated = [...multiTags];
  //   updated[index] = value;
  //   setMultiTags(updated);
  // };
  const handleAddMultitag = (push) => {
    push({
      ad_display_name: "",
      adunit_name: "",
      adunit_id: "0000",
      current_adunit: "",
      reload_adunit: "",
      htag: "",
      btag: "",
      custom_htag: "",
      custom_btag: "",
      gptid: "",
      slot_var: "",
      status: 0,
      is_visible: 0,
      cs: "",
    });
  };

     useEffect(() => {
         alldomainList();
   }, [pubId]);

  //  useEffect(() => {
  //   if (selectedDevice) {
  //     updateSlotOptions(selectedDevice); // This ensures it's set even the first time
  //   }
  // }, [selectedDevice]);

   useEffect(() => {
    console.log("Selected Device:", selectedDevice);
    console.log("Slot Options Updated:", slotOptions);
  }, [selectedDevice, slotOptions]);
  return (
    <section className="mainContainer">
      <div className="add-placement-page">
        <div className="add-placement-wrapper">
      {/* <h3 className="text-center my-3">Create Ad Placement</h3> */}
      <div className="add-placement-header">
          <h2>Create Ad Placement</h2>
          <p>Configure the ad placement details below.</p>
        </div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <div className="row">
              {formFields.map((field) => {
                if (field.hidden) return null;
                if (field.name === "elmid" && selectedGenType !== "id") return null;
                if ((field.name === "elmcl" || field.name === "elmclidx") && selectedGenType !== "class") return null;
                // if ((option.name === "desktopSlotSizes" || deviceType !== "desktop")) return null;
                // if ((option.name === "mobileSlotSizes" || deviceType !== "mobile")) return null;
                return (
                  <div key={field.name} className="col-md-12 mb-3">
                    <label>{field.label}</label>
                    {field.type === "select" ? (
                      <Field
                      as="select"
                      name={field.name}
                      className="form-control"
                      disabled={field.disabled}
                      onChange={(e) => {
                        setFieldValue(field.name, e.target.value);
                        if (field.name === "device") handleDeviceChange(e.target.value, setFieldValue);
                        if (field.name === "gen_type") setSelectedGenType(e.target.value);
                      }}
                    >
                        {/* <option value="">Select {field.label}</option> */}
                        <option value="__please_select__">Please Select</option>
                        {
                          // (
                            // field.name === "slot_size"
                            // ? (selectedDevice === "mobile"
                            //     ? mobileSlotSizes.map((size) => ({ value: size, label: size }))
                            //     : selectedDevice === "desktop"
                            //       ? desktopSlotSizes.map((size) => ({ value: size, label: size }))
                            //       : [])
                            (field.name === "slot_size"
                              ? slotOptions.map((size) => ({ value: size, label: size }))
                            : field.name === "site_id"
                              ? domainList.map((domain) => ({
                                  value: domain.id,
                                  label: domain.domain
                                }))
                              : Array.isArray(field.options) ? field.options : []
                          ).map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))
                        }
                      </Field>
                    ) : field.type === "textarea" ? (
                      <Field as="textarea" name={field.name} className="form-control" disabled={field.disabled} />
                    ) : (
                      <Field type={field.type} name={field.name} className="form-control" disabled={field.disabled} readOnly={field.readonly} />
                    )}
                    <ErrorMessage name={field.name} component="div" className="text-danger" />
                    {field.name === "btag" && (
                      <div className="mt-2">
                        <button type="button" className="applyBtn applyCustomize" onClick={() => handleCustomizeApply(values, setFieldValue)}>
                          Apply Customize
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}

              {/* ➕ Dynamic ad_multitags section */}
              <FieldArray name="ad_multitags">
                {({ push, remove }) => (
                  <>
                    {values.ad_multitags.map((_, index) => (
                      <div key={index} className="border p-4 rounded mb-4">
                        <div className="row multiInput">
                          <p style={{fontSize:"15px",fontWeight:"bold",color:"#2275ff"}}>MultiTag #{index + 1}</p>
                        <div className="col-md-12">
                          <label>Ad Display Name</label>
                          <Field className="form-control" type="text" name={`ad_multitags[${index}].ad_display_name`} placeholder="Ad Display Name" />
                        </div>
                      
                        <div className="col-md-12">
                        <label>Ad Unit Name</label>
                        <Field className="form-control" name={`ad_multitags[${index}].adunit_name`} placeholder="Ad Unit Name" />
                        </div>

                        <div className="col-md-12">
                        <label>Ad Unit ID</label>
                        <Field className="form-control" name={`ad_multitags[${index}].adunit_id`} placeholder="Ad Unit ID" />
                        </div>

                        <div className="col-md-12">
                        <label>Current Ad Unit</label>
                        <Field className="form-control" name={`ad_multitags[${index}].current_adunit`} placeholder="Current Ad Unit" />
                        </div>

                        <div className="col-md-12">
                        <label>Refresh Ad Unit</label>
                        <Field className="form-control" name={`ad_multitags[${index}].reload_adunit`} placeholder="Reload Ad Unit" />
                        </div>

                        <div className="col-md-12">
                        <label>Head Tag</label>
                        <Field className="form-control" as="textarea" name={`ad_multitags[${index}].htag`} placeholder="Head Tag" />
                        </div>
                        <ErrorMessage name={`ad_multitags[${index}].htag`} component="div" className="text-danger" />
                        
                        <div className="col-md-12">
                        <label>Body Tag</label>
                        <Field className="form-control" as="textarea" name={`ad_multitags[${index}].btag`} placeholder="Body Tag" />
                        </div>
                        <div className="col-md-12">
                            <button type="button" className="applyBtn applyCustomize my-3" onClick={() => handleMultiCustomize(index, values, setFieldValue)}>Apply Customize</button>
                        </div>
                        <ErrorMessage name={`ad_multitags[${index}].btag`} component="div" className="text-danger" />
                        <div className="col-md-12">
                        <label>Custom Head Tag</label>
                        <Field className="form-control" as="textarea" name={`ad_multitags[${index}].custom_htag`} placeholder="Custom HTag" />
                        </div>

                        <div className="col-md-12">
                        <label>Custom Body Tag</label>
                        <Field className="form-control" as="textarea" name={`ad_multitags[${index}].custom_btag`} placeholder="Custom BTag" rows="8"/>
                        </div>

                        <div className="col-md-12">
                        <label>GPT ID</label>
                        <Field className="form-control" name={`ad_multitags[${index}].gptid`} placeholder="GPT ID" />
                        </div>

                        <div className="col-md-12">
                        <label>Slot Var</label>
                        <Field className="form-control" name={`ad_multitags[${index}].slot_var`} placeholder="Slot Var" />
                        </div>
                        <div className="col-md-12">
                        <label>Status</label>
                        <Field className="form-control" as="select" name={`ad_multitags[${index}].status`}>
                          <option value="0">Yes</option>
                          <option value="1">No</option>
                        </Field>
                        </div>

                        <div className="col-md-12">
                        <label>Visible on report</label>
                        <Field className="form-control" as="select" name={`ad_multitags[${index}].is_visible`}>
                          <option value="0">Yes</option>
                          <option value="1" selected>No</option>
                        </Field>
                        </div>
                        <div className="col-md-12">
                        <label>Extra Css multiTag</label>
                        <Field className="form-control" as="textarea" name={`ad_multitags[${index}].cs`}>
                        </Field>
                        </div>
                        </div>
                      <button type="button" className="deleteBtn applyBtn mt-3" onClick={() => remove(index)}>Delete</button>
                    </div>
                    
                    ))}
                    <div className="col-md-12 addMore">
                      <button type="button" className="applyBtn addMultiTag mb-4" onClick={() => handleAddMultitag(push)}>Add Multitag</button>
                    </div>
                  </>
                )}
              </FieldArray>

            </div>
            <div className="publisher-form-actions">
             <button type="submit" className="applyBtn applyCustomize">Submit</button>
             <button type="submit" className="applyBtn cancelBtn" onClick={() => navigate(-1)}>Cancel</button>
            </div>
          </Form>
        )}
      </Formik>
      </div>
      </div>
    </section>
  );
};

export default CreateForm;
